import urls from "../urls";
import { ObjectName } from "./enums";

const DETAIL_API_BY_OBJECTS = {
  [ObjectName.Generator]: urls.api.generator,
  [ObjectName.Consumer]: urls.api.consumer,
  [ObjectName.Storage]: urls.api.storage,
  [ObjectName.Person]: urls.api.person,
  [ObjectName.Connection]: urls.apiWithoutCamelization.connection,
  [ObjectName.GasConnection]: urls.apiWithoutCamelization.gasConnection,
  [ObjectName.Meter]: urls.api.meter,
  [ObjectName.GhostNode]: urls.api.ghostNode,
  [ObjectName.MarketLocation]: urls.api.marketLocation,
  [ObjectName.MeteringLocation]: urls.api.meteringLocation,
  [ObjectName.MeteringOrMarketLocation]: urls.api.meteringOrMarketLocation
} as const;

/** Gets the "detail" (GET) URL for a given ObjectName. */
export function getObjectDetailUrl(
  objectName: ObjectName,
  componentId: number
) {
  return DETAIL_API_BY_OBJECTS[objectName](componentId);
}
